import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';

export interface RateGroup {
  /* The name the hotel gave the group in CEMA. `rateGroupId` is an opaque uuid,
     so this is the only part of a rate group fit to show a user. */
  name: string;
  rateGroupId: string;
  rateIds: string[];
}

export default class PaSubscriptionMetaInfo extends Model {
  [Type] = 'pa-subscription-meta-info' as const;

  @attr('dayjs') declare lastRecommendationsRefresh: DayjsTransformReturn;
  @attr('json') declare rateGroups: RateGroup[] | null;
  // Also used as id (primaryKey in the model serializer)
  @attr('number') declare subscriptionId: number;

  /* A rate group only counts as configured once it has rate codes mapped to it. */
  get configuredRateGroups(): RateGroup[] {
    return (this.rateGroups ?? []).filter(
      (rateGroup) => rateGroup.rateIds.length > 0,
    );
  }
}
